
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'

import { getOrderHistoryInfo, getExchangeBean } from "@/common/js/api.js";

export default {
components: {
Grid,
GridItem,
Flexbox,
FlexboxItem,
Confirm,
Toast,
XButton,
Actionsheet
},
data() {
return {
title: "",
alertshow: false,
alertTitle: "温馨提示",
alertContent: "点击确定，可一键获取鸥豆哦！",
toastsuccess: false,
toastwarn: false,
toastText: "",
OrderRewardStatus: 1,

bag_w: 0,
black_w: 0,
summer_w: 0,
shoe_w: 0,
wollens_w: 0,
winter_w: 0,
garbage_w: 0,
ExchangeBean: 0,

Carbon: 0,
heart: 0,

toastClass: false,
menuClass: {
menu1: "",
menu2: ""
},
list: [],
platform:''
};
},
methods: {
alertClass: function(type) {
switch (type) {
case "summer_w":
this.menuClass.menu1 = "夏衣诠释";
this.menuClass.menu2 =
"材质：薄款的棉质类、雪纺类、涤纶类、腈纶类、牛仔类；<br>" +
"款式：短袖、裤子、裙装；<br>" +
"用途：出口援非二次使用、贫困捐赠！<br>" +
"减碳值：1kg=200g CO<sub>2</sub>";
break;

case "winter_w":
this.menuClass.menu1 = "冬衣诠释";
this.menuClass.menu2 =
"材质：厚款的棉质类、毛线类、呢子料、皮毛类、羽绒类；<br>" +
"款式：长袖、毛衣、大衣、棉裤；<br>" +
"用途：贫困捐赠、工厂机器擦拭吸油布！<br>" +
"减碳值：1kg=150g CO<sub>2</sub>";
break;

case "bag_w":
this.menuClass.menu1 = "包包诠释";
this.menuClass.menu2 =
"材质：皮质类、帆布类、涤纶类；<br>" +
"款式：单肩包、双肩包、手提包；<br>" +
"用途：出口援非二次使用、山区捐赠、皮质类可用于发电燃料使用！<br>" +
"减碳值：1kg=125g CO<sub>2</sub>";
break;

case "shoe_w":
this.menuClass.menu1 = "鞋子诠释";
this.menuClass.menu2 =
"材质：皮质类、布类；<br>" +
"款式：球鞋、皮鞋、平底鞋；<br>" +
"用途：出口援非二次使用、贫困捐赠、皮质类可用于发电燃料使用！<br>" +
"减碳值：1kg=125g CO<sub>2</sub>";
break;

case "black_w":
this.menuClass.menu1 = "其它诠释";
this.menuClass.menu2 =
"材质：<br>&nbsp;&nbsp;&nbsp;1.破损类的衣物、脏污的衣物；塑料类、金属类等非纺织品类物品，例如：包装纸皮、纤袋、胶带或其他物品；<br>" +
"&nbsp;&nbsp;&nbsp;2.塑料类、金属类等非纺织品类物品，例如：包装纸皮、纤袋、胶带或其他物品；<br><br>" +
"用途：<br>&nbsp;&nbsp;&nbsp;1.再生布原料、汽车隔音棉、大棚保温棉、劳保产品！<br>&nbsp;&nbsp;&nbsp;2.收集整理后转入专属品类供应商进行处理！<br><br>" +
"（废纺）减碳值：1kg=150g CO<sub>2</sub><br>（垃圾）减碳值：1kg=100g CO<sub>2</sub>";
break;

default:
this.menuClass.menu1 = "毛料诠释";
this.menuClass.menu2 =
"材质：衣服面料；<br>" +
"用途：再生布原料、汽车隔音棉、大棚保温棉、劳保产品等！<br>" +
"减碳值：1kg=125g CO<sub>2</sub>";
}
this.toastClass = true;
},
alertSource: function() {

this.alertshow = true;
},
onCancel() {
this.alertshow = false;
},
onHide() {
this.alertshow = false;
},
onConfirm() {
let self = this;

getExchangeBean({ data: { orderId: this.$route.query.orderId } })
.then(function(data) {

self.toastText = data.Content;
if (data.Code == 200) {
self.toastText = "获取鸥豆成功";
self.toastsuccess = true;
self.alertshow = false;







self.ExchangeBean = data.Content.ExchangeBean;
self.Carbon = data.Content.Carbon;
self.OrderRewardStatus = 1;

} else {
self.toastwarn = true;
}
})
.catch(function(error) {
self.toastText = error.Content;
self.toastwarn = true;
});
},
getOrderHistoryInfo(orderId) {
let self = this;
getOrderHistoryInfo({ data: { orderId: orderId } }).then(function(data) {
self.bag_w = data.Content.bag_w;
self.black_w = data.Content.black_w;
self.summer_w = data.Content.summer_w;
self.shoe_w = data.Content.shoe_w;
self.wollens_w = data.Content.wollens_w;
self.winter_w = data.Content.winter_w;
self.garbage_w = data.Content.garbage_w;
self.ExchangeBean = data.Content.ExchangeBean;
self.OrderRewardStatus = data.Content.OrderRewardStatus;

self.Carbon = data.Content.Carbon;
self.heart = data.Content.heart;
self.list = data.Content.list;
self.OrderRewardStatus = data.Content.OrderRewardStatus;
for (var i = 0; i < self.list.length; i++) {
if (self.list[i].changeType == 2) {
self.list[i].content = JSON.parse(self.list[i].content);
}
}
});
}
},
created() {
const self= this
let orderId = this.$route.query.orderId;
const platform = this.$config.platform
console.log(platform)
if(platform == 'yuexiu') {
self.platform = 'yuexiu'
}
this.getOrderHistoryInfo(orderId);
}
};



// WEBPACK FOOTER //
// ./src/components/urbanService/OrderDetail.vue